import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { getCourseById, joinCourse } from '../services/firestore'
import { ArrowLeft, Users, CheckCircle, AlertCircle } from 'lucide-react'
import './JoinCourse.css'

const JoinCourse = () => {
  const { courseId } = useParams()
  const { user } = useAuth()
  const navigate = useNavigate()
  const [course, setCourse] = useState(null)
  const [loading, setLoading] = useState(true)
  const [joining, setJoining] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    loadCourse()
  }, [courseId])

  const loadCourse = async () => {
    try {
      const result = await getCourseById(courseId)
      if (result.success) {
        setCourse(result.data)
      } else {
        setError('Clase no encontrada')
      }
    } catch {
      setError('Error al cargar la clase')
    }
    setLoading(false)
  }

  const handleJoin = async () => {
    setJoining(true)
    setError('')

    try {
      const result = await joinCourse(courseId, user.uid)
      
      if (result.success) {
        navigate(`/dashboard/course/${courseId}`)
      } else {
        setError(result.error || 'Error al unirse a la clase')
      }
    } catch (err) {
      setError(err.message || 'Error al unirse a la clase')
    }

    setJoining(false)
  }

  if (loading) {
    return (
      <div className="join-course-page">
        <div className="loading">Cargando...</div>
      </div>
    )
  }

  if (error && !course) {
    return (
      <div className="join-course-page">
        <div className="error-container">
          <AlertCircle size={48} />
          <h2>Error</h2>
          <p>{error}</p>
          <button 
            className="back-button"
            onClick={() => navigate('/dashboard')}
          >
            Volver al Dashboard
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="join-course-page">
      <div className="join-course-container">
        <button 
          className="back-button"
          onClick={() => navigate('/dashboard')}
        >
          <ArrowLeft size={20} />
          Volver
        </button>

        <div className="course-details">
          <h1>{course?.name}</h1>
          <p className="description">{course?.description || 'Sin descripción'}</p>
          
          <div className="course-info">
            <div className="info-item">
              <Users size={20} />
              <span>{course?.tutors?.length || 0} tutor(es)</span>
            </div>
          </div>
        </div>

        {error && (
          <div className="error-message">
            <AlertCircle size={18} />
            <span>{error}</span>
          </div>
        )}

        <div className="join-actions">
          <button 
            className="join-button"
            onClick={handleJoin}
            disabled={joining}
          >
            <CheckCircle size={20} />
            {joining ? 'Uniéndose...' : 'Unirse a esta Clase'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default JoinCourse



